import React from 'react'
import { useTranslation } from 'react-i18next'

import { Table } from 'antd'

import { Invoice } from 'core/application/adminDashboard/companySettings/subscription/invoices'

import Button from 'common/components/general/Button'

import { parseZoneFormat } from 'common/dateFormatters'
import { formatMoney } from 'common/moneyFormatter'

interface InvoicesTableProps {
  invoices: Invoice[]
  loadingInvoices: boolean
  history: any
}

const InvoicesTable: React.FC<InvoicesTableProps> = ({ invoices, loadingInvoices, history, ...props }) => {
  const { t: translate } = useTranslation()

  const columns = [
    {
      title: translate('admin-dashboard.company-settings.subscription.date'),
      dataIndex: 'date',
      key: 'date',
      sorter: false,
      render: (text: string, record: any) => {
        return (
          <span>
            <div>
              <p> {parseZoneFormat(record.date)}</p>
            </div>
          </span>
        )
      },
    },
    {
      title: translate('admin-dashboard.company-settings.subscription.invoice-number'),
      dataIndex: 'invoiceNumber',
      key: 'invoiceNumber',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <p>{record.invoiceNumber}</p>
        </span>
      ),
    },

    {
      title: translate('admin-dashboard.company-settings.subscription.amount'),
      dataIndex: 'amount',
      key: 'amount',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <p>{formatMoney(record.amount)}</p>
        </span>
      ),
    },
    {
      title: translate('admin-dashboard.company-settings.subscription.status'),
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <p>{record.status}</p>
        </span>
      ),
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <Button
            type="link"
            onClick={() => {
              window.open(record.viewUrl, '_blank')
            }}
            className="color-blue-6"
          >
            {translate('general.view')}
          </Button>
        </span>
      ),
    },
  ]

  return <Table dataSource={invoices} loading={loadingInvoices} columns={columns} {...props} />
}

export default InvoicesTable
